import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    url: String,
    organizationId: String
  }

  selectTarget: HTMLSelectElement
  tomSelect: TomSelect
  urlValue: string
  organizationIdValue: string

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      valueField: 'id',
      labelField: 'label',
      searchField: ['label', 'email'],
      load: (query, callback) => {
        const url = `/app_users.json?organization_id=${this.organizationIdValue}&q=${encodeURIComponent(query)}`
        
        fetch(url)
          .then(response => response.json())
          .then(json => {
            callback(json.map(user => ({
              id: user.id,
              label: `${user.full_name} (${user.email})`
            })))
          })
          .catch(() => callback())
      },
      render: {
        option: function(item) {
          return `<div>${item.label}</div>`
        }
      },
      onItemAdd: (value) => {
        this.addUser(value)
        this.tomSelect.clear()
      }
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  async addUser(userId: string) {
    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content
        },
        body: JSON.stringify({ user_id: userId })
      })

      if (!response.ok) {
        throw new Error('Failed to add user')
      }

      // Let Turbo handle the stream response
      const streamText = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(streamText, 'text/html')
      doc.querySelectorAll('turbo-stream').forEach(stream => {
        Turbo.renderStreamMessage(stream.outerHTML)
      })
    } catch (error) {
      console.error('Error adding user:', error)
    }
  }
} 